export const BASE_URL = 'http://localhost:8081'
// export const API_URL = 'http://stage.dribblediary.com/api'
export const API_URL = '/api'
//export const CORS_URL = 'https://cors-anywhere.herokuapp.com/'
export const CORS_URL = ''
	
